<template>
	<div>
		<div v-if="form" class="modal_form">
			<div>
				<p class="bold">designator</p>
				<input type="text" v-model="form.data.stat.fields.designator.value">
			</div>
			<div class="form_section">
				<p class="bold">title</p>
				<input type="text" v-model="form.data.stat.fields.title.value">
			</div>
			<div class="form_section">
				<p class="bold">content</p>
				<textarea type="text" v-model="form.data.stat.fields.content.value"></textarea>
			</div>
		</div>
		<div class="modal_footer">
			<a
				@click="submit()"
				:class="{ 'is-loading': is_loading }"
				class="button is-info"
				>Submit</a
			>
		</div>
	</div>
</template>
<script>
	import { mapMutations } from 'vuex'
	export default {
		name: 'stat-form',
		props: ['payload'],
		data(){
			return {
				is_loading: false,
				form: undefined
			}
		},
		created(){
			this.init()
		},
		methods: {
			init(){
				if (this.payload.is_create) {
					this.setForm({
					  id: '',
					})
					return
				}
				this.$network_utils.getStat(this.payload.data.id).then(response => {
					this.setForm(response)
				})
			},
		    setForm (form_data) {
		      this.form = new this.$form({
		        stat: {
		          fields: {
		            designator: {
		              value: form_data.designator,
		              has_error: false,
		              validations: ['Exists']
		            },
		            title: {
		              value: form_data.title,
		              has_error: false,
		              validations: ['Exists']
		            },
		            content: {
		              value: form_data.content,
		              has_error: false,
		              validations: ['Exists']
		            },
		          },
		          request_details: {
		            method: this.payload.is_create ? 'post' : 'put',
		            url: '/stats/' + form_data.id,
		          },
		          is_used: true
		        }
		      })
		    },
		    submit () {
				let response = this.form.mySubmit()
				if (response === false) {
					return
				}
				this.is_loading = true
				response.promise.then((response) => {
					this.is_loading = false
					this.removeModal(this.payload)
				})
		    },
		    ...mapMutations('modals', ['removeModal'])
		},
	}
</script>